export const useHeadConfig = () => {
    const { public: { companyName } } = useRuntimeConfig();

    return {
        titleTemplate: (title) => title ? `${companyName} | ${title}` : companyName,
        meta: [
            { charset: 'utf-8' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        ]
    };
};
